import { Scenario } from 'z3k-config';
import { FixedBlockType } from 'console/blockly/types/block-type';
import { BlocklyError } from 'console/blockly/utils/blockly-error';
import { ifThenElseB2C, resolverB2C, } from 'console/blockly/convertors/blockly-2-config/index';
import { timeUnitsDict } from 'console/blockly/utils/time';
function linearRunB2C(config, scenario, block) {
    const [newConfig, ids] = resolverB2C(config, block.statement, []);
    return Scenario.get.modifyById(newConfig, scenario.id, (scr) => Scenario.changeScenarioType(scr, Scenario.Type.LINEAR, {
        links: ids,
        name: block.scenario_name,
    }));
}
function ifRunB2C(config, scenario, block) {
    //добавляем компаратор в конфиг
    //Юра ожидает ConditionalOperator в который будет всё завёрнуто
    const [newConfig, ids] = ifThenElseB2C(config, block, []);
    return Scenario.get.modifyById(newConfig, scenario.id, (scr) => Scenario.changeScenarioType(scr, Scenario.Type.CONDITIONAL, {
        links: ids,
        name: block.scenario_name,
    }));
}
/**
 * @function
 * 2 шаг сохранения
 * Сценарий с циклом конвертирую из Blockly json в Z3KObject
 * @param config - Z3KConfig устройства
 * @param scenario - Z3KObject сценария
 * @param block - Blockly json
 * @return Z3KConfig - обновлённый конфиг
 */
export function loopRunB2C(config, scenario, block) {
    const [newConfig, ids] = resolverB2C(config, block.statement, []);
    return Scenario.get.modifyById(newConfig, scenario.id, (scr) => Scenario.changeScenarioType(scr, Scenario.Type.LOOP, {
        links: ids,
        name: block.scenario_name,
        loop_time: block.value * timeUnitsDict[block.unit_time],
    }));
}
function scheduleRunB2C(config, scenario, block) {
    const [newConfig, ids] = resolverB2C(config, block.statement, []);
    const time = (block.hour << 8) | block.min;
    return Scenario.get.modifyById(newConfig, scenario.id, (scr) => Scenario.changeScenarioType(scr, Scenario.Type.LINEAR, {
        links: ids,
        name: block.scenario_name,
        timetable: {
            checked: true,
            weekday_register: block.weekday_register,
            time,
        },
    }));
}
export function mainB2C(config, data, scenario) {
    if (data?.type === FixedBlockType.linear) {
        return linearRunB2C(config, scenario, data);
    }
    if (data?.type === FixedBlockType.loop) {
        return loopRunB2C(config, scenario, data);
    }
    if (data?.type === FixedBlockType.if_run) {
        return ifRunB2C(config, scenario, data);
    }
    if (data?.type === FixedBlockType.schedule_run) {
        return scheduleRunB2C(config, scenario, data);
    }
    throw new BlocklyError('mainB2C', `Нет блока для запуска`);
}
